import { Component, ElementRef, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import axios from 'axios';
import { Authenticationservice } from '../../services/authentication.service';
import { BrdsqlService } from '../../services/brdsql.service';


//https://stackblitz.com/edit/angular-editable-table-part-1-f79yfj?file=src%2Fapp%2Fapp.component.ts%3AL3-L3,src%2Fapp%2Fapp.component.html%3AL12-L12,src%2Fapp%2Fapp.module.ts

@Component({
  selector: 'app-list-kpi',
  templateUrl: './list-kpi.component.html',
  styleUrls: ['./list-kpi.component.css']
})

export class ListKpiComponent {
  userdata: any;
  constructor(private auth: Authenticationservice, private spinner: NgxSpinnerService, private brdsql: BrdsqlService) {
    this.userdata = this.auth.Authention();
  }


  ngOnInit(): void {
    let selecttime1 = this.selecttime1;
    console.log('selecttime1 B:', this.selecttime1);
    let dataZ = this.brdsql.sumZonne;
    let userD = this.userdata;

    if (userD.zonedata === 'PA') {
      this.selectsup = dataZ;
    }
    else if (userD.userlevel == 15) {
      this.selectsup = dataZ.filter((el) => el[0] === userD.zonedata)
    }
    else if (userD.userlevel == 14 || userD.userlevel == 1) {
      this.selectsup = dataZ.filter((el) => el[1] === userD.zonedata)
    }

    this.edit_st = 0;
    this.type_s = 1;
    //this.Loaddata1();
    //this.Loaddata3();
    //console.log('userD',userD);
    //console.log('selectsup',this.selectsup);
    const currentDate = new Date();

    const filteredSelectTime = selecttime1.filter(item => {
      const itemDate = new Date(item[1]);
      return itemDate <= currentDate;
    });
    this.selecttime1 = filteredSelectTime;
    //console.log('filteredSelectTime:', filteredSelectTime);

  }
  scrollTo(element: any): void {
    (document.getElementById(element) as HTMLElement).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }

  selecttime1 = [
    /*
    ['งวด เม.ย. 2566', '2023-04-01'],
    ['งวด พ.ค. 2566', '2023-05-01'],
    ['งวด มิ.ย. 2566', '2023-06-01'],
    ['งวด ก.ค. 2566', '2023-07-01'],
    ['งวด ส.ค. 2566', '2023-08-01'],
    ['งวด ก.ย. 2566', '2023-09-01'],
    ['งวด ต.ค. 2566', '2023-10-01'],
    ['งวด พ.ย. 2566', '2023-11-01'],
    ['งวด ธ.ค. 2566', '2023-12-01'],
    ['งวด ม.ค. 2567', '2024-01-01'],
    ['งวด ก.พ. 2567', '2024-02-01'],
    ['งวด มี.ค. 2567', '2024-03-01'],*/
    ['งวด เม.ย. 2567', '2024-04-01'],
    ['งวด พ.ค. 2567', '2024-05-01']
  ];
  selectsup = [];
  selectP = []; selectS = [];
  type_s: number;
  edit_st: number;

  dataSource = [];

  dataApi0 = []; dataApi3 = []; dataApi1 = [];
  Loaddata1() {
    let time = this.selectP
    this.spinner.show()
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s='" + time[1] + "'Lotd,*&f=CPS6263.dbo.[fnc_brdlotwork_6701]('" + time[1] + "')&w=1=1";
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = res.data;
      if (data.length >= 1) {
        //this.selectsup = data.filter((el) => el.Supcode == 'sum').map(function (elem ){return [elem.Partcode, elem.Supzone, elem.Supcode, elem.SUPNAME]});

        for (var i = 0; i < data.length; i++) {
          for (var key in data[i]) {
            if (typeof data[i][key] === 'string' && data[i][key].startsWith('[')) {
              data[i][key] = JSON.parse(data[i][key]);
            }
          }
        }
        data = data.map(item => {
          return { ...item, modify: false };
        });
        this.dataApi0 = (data)
        //this.dataApi1 = (data).filter((el) => el.Supzone == '01');
        if (this.selectS.length > 0) {
          this.filter_data();
        }
        console.log('brdlotwork:', data)
      }
      else { this.dataApi0 = []; this.filter_data(); }

    }).catch(err => { throw (err) })
  }

  sum_sv = [];
  filter_data() {
    let aj = this.selectS;
    let userD = this.userdata;
    if (this.dataApi0.length > 0) {
      if (aj[1] != "sum") {
        this.dataApi1 = this.dataApi0.filter((el) => el.Supzone == aj[1] && el.Supcode != aj[2]);
      }
      else {
        this.dataApi1 = this.dataApi0.filter((el) => el.Partcode == aj[0] && el.Supcode != aj[2]);
      }
      this.sum_sv = this.dataApi1.map(function (el) { return el.Supcode });
      console.log('sum_sv:', this.sum_sv);

      this.dataSource = this.dataApi1
      console.log('list_sup', this.dataApi1, '/zonedata ', userD.zonedata)
    }
    else { this.dataApi1 = [] }
  }


  //`https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_t_s_w?t=[dbo].[brdlotwork]&s=[knowledge]='`+value+`' &w=Lotdate = '`+Lot+`' and supcode='`+supcode+`'`
  saveDataKpi() {
    let time = this.selectP, value = this.dataApi1.filter((el) => el.modify == true);
    let x = 0, y = 0;
    if (value.length > 0) {
      let supcode = value.map(function (elem) { return elem.Supcode });
      if (confirm('ต้องการบันทึกข้อมูล ' + supcode + ' | จำนวน ' + value.length + ' คน หรือไม่?')) {
        for (let i = 0; i < value.length; i++) {
          let url: string, ar0 = value[i]
          url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_t_s_w?t=[dbo].[brdlotwork]&s=
             [s_Success01]=${ar0.s_Success01},[mTarget01]=${ar0.mTarget01},[sTarget01]=${ar0.sTarget01},[Target1]=${ar0.Target1}
            ,[s_Success02]=${ar0.s_Success02},[mTarget02]=${ar0.mTarget02},[sTarget02]=${ar0.sTarget02},[Target2]=${ar0.Target2}
            ,[s_Success03]=${ar0.s_Success03},[mTarget03]=${ar0.mTarget03},[sTarget03]=${ar0.sTarget03},[Target3]=${ar0.Target3}
            ,[s_Success04]=${ar0.s_Success04},[mTarget04]=${ar0.mTarget04},[sTarget04]=${ar0.sTarget04},[Target4]=${ar0.Target4}
            ,[s_Success05]=${ar0.s_Success05},[mTarget05]=${ar0.mTarget05},[sTarget05]=${ar0.sTarget05},[Target5]=${ar0.Target5}
            ,[s_Success06]=${ar0.s_Success06},[mTarget06]=${ar0.mTarget06},[sTarget06]=${ar0.sTarget06},[Target6]=${ar0.Target6}
            ,[s_Success07]=${ar0.s_Success07},[mTarget07]=${ar0.mTarget07},[sTarget07]=${ar0.sTarget07},[Target7]=${ar0.Target7}
            ,[s_Success08]=${ar0.s_Success08},[mTarget08]=${ar0.mTarget08},[sTarget08]=${ar0.sTarget08},[Target8]=${ar0.Target8},[Success8]=${ar0.Success8}
            ,[s_Success09]=${ar0.s_Success09},[mTarget09]=${ar0.mTarget09},[sTarget09]=${ar0.sTarget09},[Target9]=${ar0.Target9},[Success9]=${ar0.Success9}
            ,[s_Success10]=${ar0.s_Success10},[mTarget10]=${ar0.mTarget10},[sTarget10]=${ar0.sTarget10},[Target10]=${ar0.Target10},[Success10]=${ar0.Success10}

            ,[sSuccess01er]='${JSON.stringify(ar0.sSuccess01er)}',[mTarget01er]='${JSON.stringify(ar0.mTarget01er)}',[sTarget01er]='${JSON.stringify(ar0.sTarget01er)}',[Target01er]='${JSON.stringify(ar0.Target01er)}',[Success01er]='${JSON.stringify(ar0.Success01er)}'
            ,[sSuccess02er]='${JSON.stringify(ar0.sSuccess02er)}',[mTarget02er]='${JSON.stringify(ar0.mTarget02er)}',[sTarget02er]='${JSON.stringify(ar0.sTarget02er)}',[Target02er]='${JSON.stringify(ar0.Target02er)}',[Success02er]='${JSON.stringify(ar0.Success02er)}'
            ,[sSuccess03er]='${JSON.stringify(ar0.sSuccess03er)}',[mTarget03er]='${JSON.stringify(ar0.mTarget03er)}',[sTarget03er]='${JSON.stringify(ar0.sTarget03er)}',[Target03er]='${JSON.stringify(ar0.Target03er)}',[Success03er]='${JSON.stringify(ar0.Success03er)}'
            ,[sSuccess04er]='${JSON.stringify(ar0.sSuccess04er)}',[mTarget04er]='${JSON.stringify(ar0.mTarget04er)}',[sTarget04er]='${JSON.stringify(ar0.sTarget04er)}',[Target04er]='${JSON.stringify(ar0.Target04er)}',[Success04er]='${JSON.stringify(ar0.Success04er)}'
            ,[sSuccess05er]='${JSON.stringify(ar0.sSuccess05er)}',[mTarget05er]='${JSON.stringify(ar0.mTarget05er)}',[sTarget05er]='${JSON.stringify(ar0.sTarget05er)}',[Target05er]='${JSON.stringify(ar0.Target05er)}',[Success05er]='${JSON.stringify(ar0.Success05er)}'
            ,[sSuccess06er]='${JSON.stringify(ar0.sSuccess06er)}',[mTarget06er]='${JSON.stringify(ar0.mTarget06er)}',[sTarget06er]='${JSON.stringify(ar0.sTarget06er)}',[Target06er]='${JSON.stringify(ar0.Target06er)}',[Success06er]='${JSON.stringify(ar0.Success06er)}'
            ,[sSuccess07er]='${JSON.stringify(ar0.sSuccess07er)}',[mTarget07er]='${JSON.stringify(ar0.mTarget07er)}',[sTarget07er]='${JSON.stringify(ar0.sTarget07er)}',[Target07er]='${JSON.stringify(ar0.Target07er)}',[Success07er]='${JSON.stringify(ar0.Success07er)}'

            ,[sSuccess01st]='${JSON.stringify(ar0.sSuccess01st)}',[mTarget01st]='${JSON.stringify(ar0.mTarget01st)}',[sTarget01st]='${JSON.stringify(ar0.sTarget01st)}',[Target01st]='${JSON.stringify(ar0.Target01st)}',[Success01st]='${JSON.stringify(ar0.Success01st)}'
            ,[sSuccess02st]='${JSON.stringify(ar0.sSuccess02st)}',[mTarget02st]='${JSON.stringify(ar0.mTarget02st)}',[sTarget02st]='${JSON.stringify(ar0.sTarget02st)}',[Target02st]='${JSON.stringify(ar0.Target02st)}',[Success02st]='${JSON.stringify(ar0.Success02st)}'
            ,[sSuccess03st]='${JSON.stringify(ar0.sSuccess03st)}',[mTarget03st]='${JSON.stringify(ar0.mTarget03st)}',[sTarget03st]='${JSON.stringify(ar0.sTarget03st)}',[Target03st]='${JSON.stringify(ar0.Target03st)}',[Success03st]='${JSON.stringify(ar0.Success03st)}'
            ,[sSuccess04st]='${JSON.stringify(ar0.sSuccess04st)}',[mTarget04st]='${JSON.stringify(ar0.mTarget04st)}',[sTarget04st]='${JSON.stringify(ar0.sTarget04st)}',[Target04st]='${JSON.stringify(ar0.Target04st)}',[Success04st]='${JSON.stringify(ar0.Success04st)}'
            ,[sSuccess05st]='${JSON.stringify(ar0.sSuccess05st)}',[mTarget05st]='${JSON.stringify(ar0.mTarget05st)}',[sTarget05st]='${JSON.stringify(ar0.sTarget05st)}',[Target05st]='${JSON.stringify(ar0.Target05st)}',[Success05st]='${JSON.stringify(ar0.Success05st)}'
            ,[sSuccess06st]='${JSON.stringify(ar0.sSuccess06st)}',[mTarget06st]='${JSON.stringify(ar0.mTarget06st)}',[sTarget06st]='${JSON.stringify(ar0.sTarget06st)}',[Target06st]='${JSON.stringify(ar0.Target06st)}',[Success06st]='${JSON.stringify(ar0.Success06st)}'
            ,[sSuccess07st]='${JSON.stringify(ar0.sSuccess07st)}',[mTarget07st]='${JSON.stringify(ar0.mTarget07st)}',[sTarget07st]='${JSON.stringify(ar0.sTarget07st)}',[Target07st]='${JSON.stringify(ar0.Target07st)}',[Success07st]='${JSON.stringify(ar0.Success07st)}'           

            ,[s_Success16]=${ar0.s_Success16},[mTarget16]=${ar0.mTarget16},[sTarget16]=${ar0.sTarget16},[Target16]=${ar0.Target16},[Success16]=${ar0.Success16}
            ,[s_Success17]=${ar0.s_Success17},[mTarget17]=${ar0.mTarget17},[Target17]=${ar0.Target17}
            
            ,[s_Success21]=${ar0.s_Success21},[mTarget21]=${ar0.mTarget21},[sTarget21]=${ar0.sTarget21},[Target21]=${ar0.Target21},[Success21]=${ar0.Success21}
            ,[s_Success22]=${ar0.s_Success22},[mTarget22]=${ar0.mTarget22},[sTarget22]=${ar0.sTarget22},[Target22]=${ar0.Target22},[Success22]=${ar0.Success22}
            ,[s_Success23]=${ar0.s_Success23},[mTarget23]=${ar0.mTarget23},[sTarget23]=${ar0.sTarget23},[Target23]=${ar0.Target23},[Success23]=${ar0.Success23}
            ,[s_Success24]=${ar0.s_Success24},[mTarget24]=${ar0.mTarget24},[sTarget24]=${ar0.sTarget24},[Target24]=${ar0.Target24},[Success24]=${ar0.Success24}
            ,[s_Success25]=${ar0.s_Success25},[mTarget25]=${ar0.mTarget25},[sTarget25]=${ar0.sTarget25},[Target25]=${ar0.Target25},[Success25]=${ar0.Success25}            
            ,[s_Success26]=${ar0.s_Success26},[mTarget26]=${ar0.mTarget26},[sTarget26]=${ar0.sTarget26},[Target26]=${ar0.Target26},[Success26]=${ar0.Success26} 
            ,[s_Success27]=${ar0.s_Success27},[mTarget27]=${ar0.mTarget27},[sTarget27]=${ar0.sTarget27},[Target27]=${ar0.Target27},[Success27]=${ar0.Success27}
            ,[s_Success28]=${ar0.s_Success28},[mTarget28]=${ar0.mTarget28},[sTarget28]=${ar0.sTarget28},[Target28]=${ar0.Target28},[Success28]=${ar0.Success28}

            ,[s_Success31]=${ar0.s_Success31},[mTarget31]=${ar0.mTarget31},[sTarget31]=${ar0.sTarget31},[Target31]=${ar0.Target31},[Success31]=${ar0.Success31}
            ,[s_Success32]=${ar0.s_Success32},[mTarget32]=${ar0.mTarget32},[sTarget32]=${ar0.sTarget32},[Target32]=${ar0.Target32},[Success32]=${ar0.Success32}
            ,[s_Success33]=${ar0.s_Success33},[mTarget33]=${ar0.mTarget33},[sTarget33]=${ar0.sTarget33},[Target33]=${ar0.Target33},[Success33]=${ar0.Success33}
            ,[s_Success34]=${ar0.s_Success34},[mTarget34]=${ar0.mTarget34},[sTarget34]=${ar0.sTarget34},[Target34]=${ar0.Target34},[Success34]=${ar0.Success34}
            ,[s_Success35]=${ar0.s_Success35},[mTarget35]=${ar0.mTarget35},[sTarget35]=${ar0.sTarget35},[Target35]=${ar0.Target35},[Success35]=${ar0.Success35}

            ,[DateEdit]=getdate()&w=[dataid]=${ar0.dataid}`;
          url = url.replace(/\n\s*/g, '\n');
          console.log('url is_update:', url);
          axios.post(url).then(res => {
            let data = res.data;
            if (data.rowsAffected[0] == 1) y++
            else x++
          }).catch(err => { console.log(err) })
          //console.log('url', i, ';', url)
        }
        //alert("สำเร็จ:"+y+" ไม่สำเร็จ:"+x);
        //console.log('สำเร็จ',y,'ไม่สำเร็จ',x)
        this.edit_st = 0
        setTimeout(() => {
          this.Loaddata1();
        }, 300);
      }
    }
    else alert('ยังไม่มีการแก้ไข')
  }

  printPage() {
    window.print();
  }

  THtoLocalstring(date: string) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }

}
